module.exports = __webpack_public_path__ + "img/check.a96b0338.svg";